import { InteractionMethod } from "@/constants/swipeConstants";
import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-VRRLW986S9";

interface SpotInteractionParams {
  user_id: string; // 必須パラメータに変更
  spot_id: string;
  spot_name: string;
  recommendation_id: string;
  interaction_type: "saved" | "visited" | "disliked";
  action_type: "create" | "cancel";
  interaction_method: InteractionMethod;
  user_latitude: number | null;
  user_longitude: number | null;
  spot_distance: number | null;
  card_position?: number | null;
  total_recommendations?: number | null;
  timestamp: string;
}

export const initGA = (debug = false) => {
  try {
    // GTAGが既に存在する場合も、react-ga4を初期化
    // これによりreact-ga4のAPIを使用可能にする
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gaOptions: {
        debug_mode: debug
      }
    });
    console.log("Google Analytics initialized with react-ga4");
  } catch (error) {
    console.error("Failed to initialize Google Analytics:", error);
  }
};

export const trackSpotInteraction = (params: SpotInteractionParams) => {
  // user_idが未定義の場合はエラーをスローして送信を停止
  if (!params.user_id) {
    throw new Error("Cannot send GA event: user_id is required");
  }

  try {
    const gaEventParams = {
      refloop_user_id: params.user_id,
      spot_id: params.spot_id,
      spot_name: params.spot_name,
      recommendation_id: params.recommendation_id,
      interaction_type: params.interaction_type,
      action_type: params.action_type,
      interaction_method: params.interaction_method,
      spot_distance: params.spot_distance,
      card_position: params.card_position ?? undefined,
      total_recommendations: params.total_recommendations ?? undefined,
      timestamp: params.timestamp
    };
    // イベントを送信
    ReactGA.event("spot_interaction", gaEventParams);

    console.log("GA Event sent:", "spot_interaction", gaEventParams);
  } catch (error) {
    // GAのエラーはユーザー体験を損なわないようにキャッチ
    console.error("Failed to send GA event:", error);
  }
};

export const trackPageView = (path: string) => {
  try {
    ReactGA.send({
      hitType: "pageview",
      page: path,
      title: document.title
    });
    console.log("GA PageView sent:", path);
  } catch (error) {
    console.error("Failed to send GA pageview:", error);
  }
};

interface UserProperties {
  user_id?: string;
  user_status?: string;
  [key: string]: string | number | boolean | undefined;
}

export const setUserProperties = (properties: UserProperties) => {
  try {
    // process.nextTickの代わりにsetTimeoutを使用（ブラウザ環境）
    setTimeout(() => {
      ReactGA.gtag("set", "user_properties", properties);
      console.log("GA User Properties set:", properties);
    }, 0);
  } catch (error) {
    console.error("Failed to set GA user properties:", error);
  }
};

export const setUserId = (userId: string) => {
  try {
    ReactGA.gtag("config", GA_MEASUREMENT_ID, {
      user_id: userId
    });
    console.log("GA User ID set:", userId);
  } catch (error) {
    console.error("Failed to set GA user ID:", error);
  }
};
